// Shared helpers for raw-text money inputs parsed with parseMoneyInput
// (SPEC-growchat-tenant-currency.md, Design 8).

import { AMOUNT_TOO_LARGE_ERROR, MONEY_INPUT_ERROR, UNSUPPORTED_CURRENCY_ERROR, formatMoney, getMaxAmount, getMinorUnits } from './money'
import { formatApiError } from './apiErrorMessage'

// Lives in money.js (the only module allowed to call Intl.NumberFormat);
// re-exported so existing callers keep importing it from here.
export { formatAmountForInput } from './money'

/**
 * Readable message for a parseMoneyInput error code. Reuses the product form
 * keys (C31) so no new locale keys are needed.
 */
export function moneyInputErrorMessage(t, errorCode, currency, uiLocale) {
  if (errorCode === AMOUNT_TOO_LARGE_ERROR) {
    return t('productForm.priceTooLarge', { max: formatMoney(getMaxAmount(currency), currency, uiLocale) })
  }
  if (errorCode === UNSUPPORTED_CURRENCY_ERROR) return t('productForm.priceCurrencyUnsupported')
  return getMinorUnits(currency) > 0
    ? t('productForm.priceFormatInvalidDecimal', { currency })
    : t('productForm.priceFormatInvalidInteger', { currency })
}

/**
 * Readable message for a failed money save. BE `too_many_decimals` gets the
 * input-format hint; other details (`negative_total`, ...) are shown as returned.
 */
export function moneyApiErrorMessage(t, err, currency, uiLocale) {
  if (err?.response?.data?.detail === 'too_many_decimals') {
    return moneyInputErrorMessage(t, MONEY_INPUT_ERROR, currency, uiLocale)
  }
  return formatApiError(err, t('common.requestFailed'))
}
